import { call, put } from "redux-saga/effects";
import axios from "../../axiosConfig";
import {
    ADD_NEW_SCRIPT_FAILED,
    ADD_NEW_SCRIPT_SUCCESS,
    DELETE_SCRIPT_DATA_FAILED,
    DELETE_SCRIPT_DATA_SUCCESS,
    EDIT_SCRIPT_DATA_FAILED,
    EDIT_SCRIPT_DATA_SUCCESS,
    GET_NAME_LIST_FAILED,
    GET_NAME_LIST_SUCCESS,
    GET_NAME_VALUE_FAILED,
    GET_NAME_VALUE_SUCCESS,
    GET_SCRIPT_FAILED,
    GET_SCRIPT_SUCCESS
} from "../Actions/JsConfigAction";

export function* GetNameListSaga(action: any): unknown {
    try {
        const response = yield call(axios.get, `getNames?type=${action.payload}`);
        const { data, status } = response
        // console.log(response);

        if (status === 200) {
            yield put({ type: GET_NAME_LIST_SUCCESS, payload: data });
        }

    } catch (e: any) {
        yield put({ type: GET_NAME_LIST_FAILED, payload: [] });
    }
}


export function* GetNameValueSaga(action: any): unknown {

    try {
        const response = yield call(axios.get, `getValues?name=${action.payload}`);
        const { data, status } = response
        // console.log(response);

        if (status === 200) {
            yield put({ type: GET_NAME_VALUE_SUCCESS, payload: data });
        }

    } catch (e: any) {
        yield put({ type: GET_NAME_VALUE_FAILED, payload: [] });
    }
}

export function* GetScriptSaga(action: any): unknown {

    try {
        const response = yield call(axios.get, `getScript?value=${action.payload}`);
        const { data, status } = response

        if (status === 200) {
            yield put({ type: GET_SCRIPT_SUCCESS, payload: data[0] });
        }

    } catch (e: any) {
        yield put({ type: GET_SCRIPT_FAILED, payload: '' });
    }
}

export function* AddNewScriptSaga(action: any): unknown {

    try {
        const response = yield call(axios.post, 'newScript', action.payload);
        const { 
            //data, 
            status 
        } = response
        // console.log(response);

        if (status === 200) {
            yield put({ type: ADD_NEW_SCRIPT_SUCCESS, payload: true });
        }

    } catch (e: any) {
        yield put({ type: ADD_NEW_SCRIPT_FAILED, payload: false });
    }
}

export function* EditScriptDataSaga(action: any): unknown {

    try {
        const { _id, ...restData } = action.payload
        const response = yield call(axios.post, `modify-Script?tagId=${_id}`, { ...restData, button: 'edit' });
        const { 
            //data, 
            status 
        } = response

        if (status === 200) {
            yield put({ type: EDIT_SCRIPT_DATA_SUCCESS, payload: true });
        }

    } catch (e: any) {
        yield put({ type: EDIT_SCRIPT_DATA_FAILED, payload: false });
    }
}

export function* DeleteScriptDataSaga(action: any): unknown {
    // console.log('AddNewScriptSaga', action.payload);

    try {
        const response = yield call(axios.post, `modify-Script?tagId=${action.payload}`, { button: 'delete' });
        const { 
            //data, 
            status 
        } = response
        // console.log(response);

        if (status === 200) {
            yield put({ type: DELETE_SCRIPT_DATA_SUCCESS, payload: true });
        }

    } catch (e: any) {
        yield put({ type: DELETE_SCRIPT_DATA_FAILED, payload: false });
    }
}